import { TranslationGroup } from '../tanslation-group';
import { en } from './en'
import { zh } from './zh'

export const formatTranslationGroup = {
    groupName: "Format",
    translations: {
        en: en,
        zh: zh
    }
} as TranslationGroup